<div class="services">
  <a (click)="toggleAll()" class="toggle-all pull-right">Toggle all</a>
  @for (workflow of workflows | values; track workflow) {
  <fieldset class="workflow">
    <legend class="block-header">{{ workflow.label }}</legend>
    <div class="block-content">
      <div class="col-sm-12 one-row">
        @for (service of services[workflow.id]; track service) {
        <div class="row">
          <label class="col-sm-4 control-label">{{ service.name }}</label>
          <div class="col-sm-8 field-wrap">
            @if (service.variations) {
            <div>
              @for (variation of service.variations | values; track variation) {
              <label [class.disabled]="service.locked" class="col-sm-8">
                <input
                  [ngModel]="variation.enabled"
                  [disabled]="service.locked"
                  (ngModelChange)="toggle(variation)"
                  type="checkbox"
                />
                <span>{{ variation.value }} {{ variation.label }}</span>
              </label>
              }
            </div>
            } @if (!service.variations) {
            <div>
              <label [class.disabled]="service.locked" class="col-sm-8">
                <input
                  [ngModel]="service.enabled"
                  [disabled]="service.locked"
                  (ngModelChange)="toggle(service)"
                  type="checkbox"
                />
              </label>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </fieldset>
  }
</div>
